import apiClient from "@/app/api/client";
import { plantContractsEndpoints, replaceParams } from "@/app/api/endpoints";
import type {
	CreatePlantContractRequest,
	PlantContract,
	PlantContractListParams,
	PlantContractPaginatedResponse,
	SuccessResponse,
	UpdatePlantContractRequest,
} from "../types";

export const plantContractService = {
	async list(params?: PlantContractListParams): Promise<PlantContractPaginatedResponse> {
		const response = await apiClient.get<PlantContractPaginatedResponse>(
			plantContractsEndpoints.list,
			{ params }
		);
		return response.data;
	},

	async getById(id: string): Promise<PlantContract> {
		const url = replaceParams(plantContractsEndpoints.getById, { id });
		const response = await apiClient.get<SuccessResponse<PlantContract>>(url);
		return response.data.data;
	},

	async create(data: CreatePlantContractRequest): Promise<PlantContract> {
		const response = await apiClient.post<SuccessResponse<PlantContract>>(
			plantContractsEndpoints.create,
			data
		);
		return response.data.data;
	},

	async update(id: string, data: UpdatePlantContractRequest): Promise<PlantContract> {
		const url = replaceParams(plantContractsEndpoints.update, { id });
		const response = await apiClient.put<SuccessResponse<PlantContract>>(url, data);
		return response.data.data;
	},

	async delete(id: string): Promise<void> {
		const url = replaceParams(plantContractsEndpoints.delete, { id });
		await apiClient.delete(url);
	},
};
